import { createSlice } from '@reduxjs/toolkit';

const stateSlice = createSlice({
  name: 'helpPanel/state',
  initialState: false,
  reducers: {
    toggleHelpPanel: (state, action) => !state,
    openHelpPanel: (state, action) => true,
    closeHelpPanel: (state, action) => false,
  },
});

export const { toggleHelpPanel, openHelpPanel, closeHelpPanel } = stateSlice.actions;

export const selectHelpPanelState = ({ helpPanel }) => helpPanel.state;

export default stateSlice.reducer;
